import VideoView from "shared/lib/interfaces/VideoView";
import apiAxios from "../apiAxios";

export async function getParticipantVideoViews(
  participantId: number
): Promise<VideoView[]> {
  return (await apiAxios.get(`/participants/${participantId}/videos/views`))
    .data;
}
